import React from 'react';
import MiroLikeWhiteboard from '../MiroLikeWhiteboard';

export default function WhiteboardTabContent({
  currentWhiteboard, whiteboardContents, whiteboardHandlers,
  isStudent, remote, publishStudentWhiteboardPatch, publishWhiteboardPatch,
  isFollowMode, publishViewport, setWhiteboardCreators, currentTab,
  lessonMode, currentUser, lessonId,
}) {
  // Для новых whiteboard'ов передаем undefined чтобы они начинали с пустого состояния
  const whiteboardContent = whiteboardContents[`whiteboard-${currentWhiteboard.id}`];

  // console.log(`Rendering whiteboard ${currentWhiteboard.id} with content:`, whiteboardContent);

  return (
    <MiroLikeWhiteboard
      key={`whiteboard-${currentWhiteboard.id}`} // Принудительно создаем новый экземпляр для каждой доски
      id={currentWhiteboard.id}
      initialContent={whiteboardContent} // undefined для новых досок = пустое состояние
      onContentChange={whiteboardHandlers[currentWhiteboard.id]}
      remotePatch={
        isStudent && remote && String(remote.wbTargetId) === String(currentWhiteboard.id)
          ? remote.wbPatch || null
          : (!isStudent && remote && String(remote.studentWbTargetId) === String(currentWhiteboard.id)
            ? remote.studentWbPatch || null
            : null)
      }
      onBroadcastPatch={
        isStudent && publishStudentWhiteboardPatch
          ? (patch) => { try { publishStudentWhiteboardPatch(currentWhiteboard.id, patch); } catch (_) {} }
          : (!isStudent && publishWhiteboardPatch
            ? (patch) => { try { publishWhiteboardPatch(currentWhiteboard.id, patch); } catch (_) {} }
            : undefined)
      }
      onBroadcastViewport={!isStudent && isFollowMode && publishViewport ? publishViewport : undefined}
      remoteViewport={isStudent && isFollowMode ? (remote?.wbViewport || null) : null}
      onInsertText={(createTextElement, createExerciseElement, createMaterialElement, setPdfModal, createGridElement) => {
        setWhiteboardCreators(prev => ({
          ...prev,
          [currentTab]: {
            createTextElement,
            createExerciseElement,
            createMaterialElement,
            setPdfModal,
            createGridElement,
          }
        }));
      }}
      isStudent={isStudent}
      isViewOnly={lessonMode === 'view_only'}
      userId={currentUser?.id || null}
      lessonId={lessonId || null}
    />
  );
}
